// src/utils/eventBus.ts

type EventCallback = (...args: any[]) => void;

interface EventBus {
  // Adicione a propriedade 'listeners' à interface
  listeners: { [key: string]: EventCallback[] }; // <-- CORREÇÃO AQUI

  on(eventName: string, callback: EventCallback): void;
  off(eventName: string, callback: EventCallback): void;
  emit(eventName: string, ...args: any[]): void;
}

const eventBus: EventBus = {
  // Inicialize listeners aqui, conforme declarado na interface
  listeners: {}, // <-- CORREÇÃO AQUI: Inicializado como um objeto vazio

  on(eventName: string, callback: EventCallback) {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];
    }
    this.listeners[eventName].push(callback);
  },

  off(eventName: string, callback: EventCallback) {
    if (!this.listeners[eventName]) return;
    this.listeners[eventName] = this.listeners[eventName].filter(
      (cb: EventCallback) => cb !== callback // <-- CORREÇÃO AQUI: Tipagem explícita para 'cb'
    );
  },

  emit(eventName: string, ...args: any[]) {
    if (!this.listeners[eventName]) return;
    this.listeners[eventName].forEach((callbackItem: EventCallback) => callbackItem(...args)); // <-- CORREÇÃO AQUI: Tipagem explícita para 'callbackItem'
  },
};

export default eventBus;